import React, { useEffect, useCallback } from 'react';
import { NavLink, useNavigate, Outlet, useLocation, Navigate } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';
import { LayoutDashboard, Briefcase, LogOut, MessageSquare, Layers, Inbox } from 'lucide-react';
import './Admin.css';

export function AdminLayout() {
  const { language } = useLanguage();
  const isRtl = language === 'ar';
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = useCallback((reason = '') => {
    localStorage.removeItem('token');
    localStorage.removeItem('auth_token');
    localStorage.removeItem('isAdmin');
    localStorage.removeItem('lastActivity');
    window.location.replace('/login');
  }, []);

  useEffect(() => {
    const enforceSecurity = () => {
      const validToken = localStorage.getItem('token') || localStorage.getItem('auth_token');
      const validAdmin = localStorage.getItem('isAdmin');
      if (!validToken || validAdmin !== 'true') {
        window.location.replace('/login');
      }
    };
    enforceSecurity();
    window.addEventListener('popstate', enforceSecurity);
    window.addEventListener('focus', enforceSecurity);

    return () => {
      window.removeEventListener('popstate', enforceSecurity);
      window.removeEventListener('focus', enforceSecurity);
    };
  }, []);

  const currentToken = localStorage.getItem('token') || localStorage.getItem('auth_token');
  const currentAdmin = localStorage.getItem('isAdmin');
  if (!currentToken || currentAdmin !== 'true') {
    return <Navigate to="/login" replace />;
  }

  return (
    <div className="admin-dashboard" dir={isRtl ? 'rtl' : 'ltr'}>
      <aside className="admin-sidebar">
        <div className="sidebar-header">
          <NavLink to="/" className="sidebar-logo">AYONK ADMIN</NavLink>
        </div>

        <nav className="sidebar-menu">
          <NavLink to="/admin" end className={({ isActive }) => `sidebar-item ${isActive ? 'active' : ''}`}>
            <LayoutDashboard size={20} />
            <span>{isRtl ? 'لوحة التحكم' : 'Dashboard'}</span>
          </NavLink>

          <NavLink to="/admin/projects" className={({ isActive }) => `sidebar-item ${isActive ? 'active' : ''}`}>
            <Briefcase size={20} />
            <span>{isRtl ? 'المشاريع' : 'Projects'}</span>
          </NavLink>

          <NavLink to="/admin/services" className={({ isActive }) => `sidebar-item ${isActive ? 'active' : ''}`}>
            <Layers size={20} />
            <span>{isRtl ? 'الخدمات' : 'Services'}</span>
          </NavLink>

          <NavLink to="/admin/testimonials" className={({ isActive }) => `sidebar-item ${isActive ? 'active' : ''}`}>
            <MessageSquare size={20} />
            <span>{isRtl ? 'آراء العملاء' : 'Testimonials'}</span>
          </NavLink>

          {/* THE NEW INBOX TAB */}
          <NavLink to="/admin/contact" className={({ isActive }) => `sidebar-item ${isActive ? 'active' : ''}`}>
            <Inbox size={20} />
            <span>{isRtl ? 'صندوق الوارد' : 'Inbox'}</span>
          </NavLink>

          <button onClick={() => handleLogout("Manual logout")} className="sidebar-item logout">
            <LogOut size={20} />
            <span>{isRtl ? 'تسجيل الخروج' : 'Logout'}</span>
          </button>
        </nav>
      </aside>

      <main className="admin-main">
        <Outlet />
      </main>
    </div>
  );
}

export const StatCard = ({ icon, count, label }) => (
  <div className="stat-card">
    <div className="stat-icon">{icon}</div>
    <div className="stat-info">
      <span className="count">{count}</span>
      <span className="label">{label}</span>
    </div>
  </div>
);
